

import React, { memo } from 'react';
import Icon from '../../Icon';
import { Image } from '../../Image';
import '../styles/_dropdownFiltersSelectedItem.scss';













const DropdownFiltersGroupSelectedItem = (props) => {
  const {
    onDelete,
    label,
    icon,
    iconColour,
    iconBackground,
    imageUrl,
    value,
    placeholder,
    circular = true
  } = props;

  return (
    <div className="dropdown-selected-item__container">
      <div className="dropdown-selected-item__container--icon">
        {
        (imageUrl || icon || placeholder) &&

        <Image
          imageUrl={imageUrl}
          height="20px"
          width="20px"
          circular={circular}
          defaultImageIcon={icon}
          defaultIconColour={iconColour}
          defaultIconBackground={iconBackground}
          backgroundSize="cover"
          defaultIconSize={20}
          placeholderText={placeholder}
          placeholderTextSize={10} />}



      </div>
      <div className="dropdown-selected-item__container--label">
        {
        // $FlowFixMe
        label}

      </div>
      <div>
        <Icon
          size={10}
          className="dropdown-selected-item__close-icon"
          color="michael"
          name="close"
          onClick={() => onDelete(value)} />

      </div>
    </div>);

};

export default memo(DropdownFiltersGroupSelectedItem);